const makeInitialState = data => ({
  id: data ? data.id : '',
  name: data ? data.name : '',
  type: data ? data.type : ''
});

export default makeInitialState;
